import http from 'hub-http/clients/apiClient';
import { useEffect, useState } from 'react';
export const useAvatars = ({
  emails
}) => {
  const [avatars, setAvatars] = useState({
    hubSpotUserEmails: {}
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [emailsTested, setEmailsTested] = useState([]);
  const emailsToTest = emails.filter(email => !emailsTested.includes(email));
  useEffect(() => {
    if (emailsToTest.length > 0 && loading !== true) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setLoading(true);
      setEmailsTested(prev => [...prev, ...emailsToTest]);
      http.post(`avatars/v1/avatars/batch`, {
        data: {
          hubSpotUserEmails: emailsToTest,
          sizeParams: {
            width: 24,
            height: 24
          }
        }
      }).then(result => {
        if (result && result.hubSpotUserEmails) {
          setAvatars(result);
        }
      }).catch(e => {
        setError(e);
      }).finally(() => {
        setLoading(false);
      });
    }
  }, [emailsToTest, loading]);
  return {
    data: avatars,
    loading,
    error
  };
};